// inject import
import { measurementsSlice } from './measurements/measurements.slice';
import { DXAReadingsSlice } from './DXAReadings/DXAReadings.slice';
import { QCTReadingsSlice } from './QCTReadings/QCTReadings.slice';
import { ClinicalTrialTeamPageSlice } from './ClinicalTrialTeamPage/ClinicalTrialTeamPage.slice';
import { activateClinicalTrialSlice } from './activate/activateClinicalTrialSlice';
import { clinicalTrialAffiliatesSlice } from './clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { clinicalTrialContextSlice } from './clinicalTrialContext/clinicalTrialContext.slice';
import { clinicalTrialSubscriptionSlice } from './clinicalTrialSubscription/clinicalTrialSubscription.slice';
import { clinicalTrialNotificationHistorySlice } from './clinicalTrialNotificationHistory/clinicalTrialNotificationHistory.slice';
import { clinicalTrialSiteRecipientsSlice } from './clinicalTrialSiteRecipients/clinicalTrialSiteRecipients.slice';
import { breadcrumbsSlice } from './breadcrumbs/breadcrumbs.slice';
import { teamFiltersSlice } from './teamFilters/teamFilters.slice';
import { usersFiltersSlice } from './usersFilters/usersFilters.slice';
import { authSlice } from './auth/auth.slice';
import { affiliationUsersListSlice } from './affiliationUsersList/affiliationUsersList.slice';
import { usersListSlice } from './usersList/usersList.slice';
import { invitationsUserManagementSlice } from './invitationsUserManagement/invitationsUserManagement.slice';
import { teamMembersListSlice } from './teamMembersList/teamMembersList.slice';
import { SiteSubjectsListSlice } from './SiteSubjectsList/SiteSubjectsList.slice';
import { settingsSlice } from './settings/settings.slice';
import { QCTaskUploadsListSlice } from './QCTaskUploadsList/QCTaskUploadsList.slice';
import { QCTaskSlice } from './QCTask/QCTask.slice';
import { QCTaskSeriesSlice } from './QCTaskSeries/QCTaskSeries.slice';
import { clinicalTrialSlice } from './clinicalTrial/clinicalTrial.slice';
import { clinicalTrialsListSlice } from './clinicalTrialsList/clinicalTrialsList.slice';
import { facilitesSlice } from './facilities/facilities.slice';
import { imagingLabelsSlice } from './imagingLabels/imagingLabels.slice';
import { inventorySlice } from './inventory/inventory.slice';
import { organizationsSlice } from './organizations/organizations.slice';
import { paginationAndSortSlice } from './paginationAndSort/paginationAndSort.slice';
import { QCTaskCommentsSlice } from './QCTaskComments/QCTaskComments.slice';
import { QCTaskPatientSlice } from './QCTaskPatient/QCTaskPatient.slice';
import { QCTasksListSlice } from './QCTasksList/QCTasksList.slice';
import { auditTrialsSlice } from './auditTrailsFilters/auditFilters.slice';
import { DICOMViewerSlice } from './DICOMViewer/DICOMViewer.slice';
import { readerTaskSlice } from './readerTask/readerTask.slice';
import { readerCacheSlice } from './readerCache/readerCache.slice';
import { ReaderTasksListSlice } from './ReaderTasks/ReaderTasksList.slice';
import { clinicalTrialInventorySlice } from './clinicalTrialInventory/clinicalTrialInventory.slice';
import { DXAScoringFormSlice } from './DXAScoringForm/DXAScoringForm.slice';
import { EDTFSlice } from './EDTF/EDTF.slice';
import { qcTaskDefinitionSlice } from './QCTaskDefinition/QCTaskDefinition.slice';
import { pmTaskDefinitionSlice } from './PMTaskDefinition/PMTaskDefinition.slice';
import { siteUploadSlice } from './siteUpload/siteUpload.slice';
import { clinicalTrialReportsSlice } from '@restore/clinicalTrialReports/clinicalTrialReports.slice';
import { qcTaskExecutionsSlice } from './QCTaskExecutions/QCTaskExecutions.slice';
import { DICOMViewerProcessesSlice } from './DICOMViewerProcesses/DICOMViewerProcesses.slice';
import { workflowsSlice } from '@restore/workflows/workflows.slice';
import { SponsorOverviewSlice } from '@restore/sponsorOverview/sponsorOverview.slice';
import { sponsorOverviewFiltersSlice } from '@restore/sponsorOverviewFilters/sponsorOverviewFilters.slice';
import { SponsorEligibilitySlice } from '@restore/sponsorEligibility';
import { SponsorStatisticsSlice } from '@restore/sponsorStatistics';
import { questionnairesSlice } from '@restore/questionnaires/questionnaires.slice';
import { clinicalTrialForms } from '@restore/clinicalTrialForms/clinicalTrialForms.slice';
import { QCPatientVisitsDatesSlice } from '@restore/QCPatientVisitsDates/QCPatientVisitsDates.slice';
import { readerSubTaskSlice } from './readerSubTask/readerSubTask.slice';
import { readerTaskOrchestrationSlice } from './readerTaskOrchestration/readerTaskOrchestration.slice';
import { clinicalTrialFiltersSlice } from '@restore/clinicalTrialFilters/clinicalTrialFilters.slice';
import { formManagementSlice } from './readerViewerSession/formManagement/formManagement.slice';
import { tabCoordinationSlice } from './readerViewerSession/tabCoordination/tabCoordination.slice';
import { segmentationSlice } from './segmentation/segmentation.slice';
import { SupportSubjectSlice } from '@restore/SupportSubject/SupportSubject.slice';
import { qcQueriesSlice } from './qcQueries/qcQueries.slice';
import { siteUserQueriesSlice } from './siteUserQueries/siteUserQueries.slice';
import { queriesSlice } from './queries/queries.slice';
import { ExternalUserSubjectsSlice } from '@restore/ExternalUserSubjects/ExternalUserSubjects.slice';
import { ExternalUserReportsSlice } from '@restore/ExternalUserReports/ExternalUserReports.slice';
import { ExternalUserViewSlice } from '@restore/ExternalUserView/externalUserView.slice';
import { ValidationSpecialistSubjectsSlice } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.slice';
import { ValidationSpecialistQuestionnairesSlice } from '@restore/ValidationSpecialistQuestionnaires/ValidationSpecialistQuestionnaires.slice';
import { SimpleViewerSlice } from './DICOMViewer/modes/SimpleViewer/SimpleViewer.slice';

// Only SHARED
export const _reducer = {
  auth: authSlice.reducer,
  settings: settingsSlice.reducer,
  breadcrumbs: breadcrumbsSlice.reducer,
  clinicalTrialContext: clinicalTrialContextSlice.reducer,
  clinicalTrialAffiliates: clinicalTrialAffiliatesSlice.reducer,
  paginationAndSort: paginationAndSortSlice.reducer,
  [ExternalUserViewSlice.name]: ExternalUserViewSlice.reducer,
};

export const reducer = _reducer as typeof _reducer & {
  [inventorySlice.name]: typeof inventorySlice.reducer;
  [facilitesSlice.name]: typeof facilitesSlice.reducer;
  [readerTaskOrchestrationSlice.name]: typeof readerTaskOrchestrationSlice.reducer;
  [organizationsSlice.name]: typeof organizationsSlice.reducer;
  [ClinicalTrialTeamPageSlice.name]: typeof ClinicalTrialTeamPageSlice.reducer;
  [clinicalTrialSlice.name]: typeof clinicalTrialSlice.reducer;
  [clinicalTrialInventorySlice.name]: typeof clinicalTrialInventorySlice.reducer;
  [clinicalTrialReportsSlice.name]: typeof clinicalTrialReportsSlice.reducer;
  [clinicalTrialsListSlice.name]: typeof clinicalTrialsListSlice.reducer;
  [clinicalTrialSubscriptionSlice.name]: typeof clinicalTrialSubscriptionSlice.reducer;
  [clinicalTrialNotificationHistorySlice.name]: typeof clinicalTrialNotificationHistorySlice.reducer;
  [clinicalTrialSiteRecipientsSlice.name]: typeof clinicalTrialSiteRecipientsSlice.reducer;
  [affiliationUsersListSlice.name]: typeof affiliationUsersListSlice.reducer;
  [activateClinicalTrialSlice.name]: typeof activateClinicalTrialSlice.reducer;
  [clinicalTrialFiltersSlice.name]: typeof clinicalTrialFiltersSlice.reducer;
  [teamFiltersSlice.name]: typeof teamFiltersSlice.reducer;
  [usersFiltersSlice.name]: typeof usersFiltersSlice.reducer;
  [usersListSlice.name]: typeof usersListSlice.reducer;
  [invitationsUserManagementSlice.name]: typeof invitationsUserManagementSlice.reducer;
  [teamMembersListSlice.name]: typeof teamMembersListSlice.reducer;
  [imagingLabelsSlice.name]: typeof imagingLabelsSlice.reducer;
  [workflowsSlice.name]: typeof workflowsSlice.reducer;
  [questionnairesSlice.name]: typeof questionnairesSlice.reducer;
  [pmTaskDefinitionSlice.name]: typeof pmTaskDefinitionSlice.reducer;
  [clinicalTrialForms.name]: typeof clinicalTrialForms.reducer;
  [SimpleViewerSlice.name]: typeof SimpleViewerSlice.reducer;

  [SponsorOverviewSlice.name]: typeof SponsorOverviewSlice.reducer;
  [sponsorOverviewFiltersSlice.name]: typeof sponsorOverviewFiltersSlice.reducer;
  [SponsorEligibilitySlice.name]: typeof SponsorEligibilitySlice.reducer;
  [SponsorStatisticsSlice.name]: typeof SponsorStatisticsSlice.reducer;
  [auditTrialsSlice.name]: typeof auditTrialsSlice.reducer;

  [SiteSubjectsListSlice.name]: typeof SiteSubjectsListSlice.reducer;
  [siteUploadSlice.name]: typeof siteUploadSlice.reducer;

  [DXAReadingsSlice.name]: typeof DXAReadingsSlice.reducer;
  [QCTReadingsSlice.name]: typeof QCTReadingsSlice.reducer;
  [QCTaskCommentsSlice.name]: typeof QCTaskCommentsSlice.reducer;

  [DXAScoringFormSlice.name]: typeof DXAScoringFormSlice.reducer;
  [measurementsSlice.name]: typeof measurementsSlice.reducer;
  [DICOMViewerSlice.name]: typeof DICOMViewerSlice.reducer;
  [SimpleViewerSlice.name]: typeof SimpleViewerSlice.reducer;
  [ReaderTasksListSlice.name]: typeof ReaderTasksListSlice.reducer;
  [readerTaskSlice.name]: typeof readerTaskSlice.reducer;
  [readerCacheSlice.name]: typeof readerCacheSlice.reducer;
  [readerSubTaskSlice.name]: typeof readerSubTaskSlice.reducer;
  [readerTaskOrchestrationSlice.name]: typeof readerTaskOrchestrationSlice.reducer;

  [QCTaskPatientSlice.name]: typeof QCTaskPatientSlice.reducer;
  [QCTaskSeriesSlice.name]: typeof QCTaskSeriesSlice.reducer;
  [QCTasksListSlice.name]: typeof QCTasksListSlice.reducer;
  [QCPatientVisitsDatesSlice.name]: typeof QCPatientVisitsDatesSlice.reducer;
  [QCTaskUploadsListSlice.name]: typeof QCTaskUploadsListSlice.reducer;
  [QCTaskSlice.name]: typeof QCTaskSlice.reducer;
  [EDTFSlice.name]: typeof EDTFSlice.reducer;
  [DICOMViewerProcessesSlice.name]: typeof DICOMViewerProcessesSlice.reducer;
  [qcTaskDefinitionSlice.name]: typeof qcTaskDefinitionSlice.reducer;
  [qcTaskExecutionsSlice.name]: typeof qcTaskExecutionsSlice.reducer;
  [formManagementSlice.name]: typeof formManagementSlice.reducer;
  [tabCoordinationSlice.name]: typeof tabCoordinationSlice.reducer;
  [segmentationSlice.name]: typeof segmentationSlice.reducer;
  [SupportSubjectSlice.name]: typeof SupportSubjectSlice.reducer;
  [qcQueriesSlice.name]: typeof qcQueriesSlice.reducer;
  [siteUserQueriesSlice.name]: typeof siteUserQueriesSlice.reducer;
  [queriesSlice.name]: typeof queriesSlice.reducer;
  [ExternalUserSubjectsSlice.name]: typeof ExternalUserSubjectsSlice.reducer;
  [ExternalUserReportsSlice.name]: typeof ExternalUserReportsSlice.reducer;
  [ExternalUserViewSlice.name]: typeof ExternalUserViewSlice.reducer;
  [ValidationSpecialistSubjectsSlice.name]: typeof ValidationSpecialistSubjectsSlice.reducer;
  [ValidationSpecialistQuestionnairesSlice.name]: typeof ValidationSpecialistQuestionnairesSlice.reducer;
};
